import React from 'react';
import { createPortal } from 'react-dom';

const EyeIcon = () => (
  <svg
    viewBox="0 0 18 18"
    width="22"
    height="22"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1.5 9S4.5 3.75 9 3.75 16.5 9 16.5 9 13.5 14.25 9 14.25 1.5 9 1.5 9Z" />
    <circle cx="9" cy="9" r="2.25" />
  </svg>
);

const EyeOffIcon = () => (
  <svg
    viewBox="0 0 18 18"
    width="22"
    height="22"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7.35 4.05A6.9 6.9 0 0 1 9 3.9c4.5 0 7.5 5.1 7.5 5.1a13 13 0 0 1-2.4 2.85" />
    <path d="M4.5 5.4A12.8 12.8 0 0 0 1.5 9s3 5.1 7.5 5.1a7.4 7.4 0 0 0 2.85-.6" />
    <path d="M7.65 7.65a2 2 0 0 0 2.7 2.7" />
    <path d="M2.7 2.7 15.3 15.3" />
  </svg>
);

// Shows or hides a text field's toolbar, on the canvas and on the form the initiator
// fills alike. It is rendered into Quill's own container, so it sits on the first line of
// the text however tall the toolbar above the field happens to be, and it takes no room
// of its own - the text is in the same place whether the toolbar is up or not.
export const EditorToolbarToggle = ({ container, isToolbarShown, onToggle }) => {
  if (!container) return null;

  return createPortal(
    <button
      type="button"
      className="fb-editor-toggle"
      title={isToolbarShown ? 'Hide Toolbar' : 'Show Toolbar'}
      aria-label={isToolbarShown ? 'Hide Toolbar' : 'Show Toolbar'}
      onMouseDown={(event) => event.preventDefault()}
      onClick={onToggle}
    >
      {isToolbarShown ? <EyeOffIcon /> : <EyeIcon />}
    </button>,
    container,
  );
};
